export const OPEN_SHIFT_LIST_PAGE_SIZE = 50;
